import { render, staticRenderFns } from "./BaseActivationPiece.vue?vue&type=template&id=7bf0b019&scoped=true&"
import script from "./BaseActivationPiece.vue?vue&type=script&lang=js&"
export * from "./BaseActivationPiece.vue?vue&type=script&lang=js&"
import style0 from "./BaseActivationPiece.vue?vue&type=style&index=0&id=7bf0b019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf0b019",
  null
  
)

export default component.exports